export default {
  computed: {
    headerHeight () {
      return this.$header.isVisible ? this.$header.height : 0
    },
  },
}
